<template>
  <div>
    <button
      class="d-none"
      data-toggle="modal"
      data-target="#teamModal"
      ref="openAddTeamsModal"
      @click="resetForm"
    ></button>

    <div class="modal fade" tabindex="-1" role="dialog" id="teamModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title m-0">Add Team</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeManageAddParks"
              @click="resetForm"
            >
              <img src="../../../assets/Svg/close.svg" />
            </button>
          </div>
          <div class="modal-body overflow-auto">
            <form>
              <span
                class="label-type error event-error mt-2"
                v-if="errorMessage != ''"
              >
                {{ errorMessage }}
              </span>

              <div class="container-fluid p-0">
                <div class="row no-gutters">
                  <div class="col-12 p-0">
                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        required
                        v-model="teamName"
                        v-on:keyup="errorNullTeam"
                        :class="{
                          'is-invalid': $v.teamName.$error,
                          'is-valid': !$v.teamName.$invalid,
                        }"
                      />
                      <span class="placeholder">Team Name</span>
                      <span
                        v-if="!$v.teamName.required"
                        class="invalid-tooltip"
                      >
                        Team name is required
                      </span>
                    </div>

                    <div class="form-group">
                      <select
                        class="form-control"
                        :class="{ filled: state }"
                        v-model="state"
                        @change="errorNullTeam"
                      >
                        <option
                          v-for="option in stateOptions"
                          :key="option.abbreviation"
                          :value="option.name"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="placeholder">State</span>
                    </div>

                    <div class="form-group">
                      <select
                        class="form-control"
                        :class="{ filled: region }"
                        v-model="region"
                        @change="errorNullTeam"
                        name="region"
                      >
                        <option value="Far West">Far West</option>
                        <option value="NorthWest">NorthWest</option>
                        <option value="North">North</option>
                        <option value="Southwest">Southwest</option>
                        <option value="Central">Central</option>
                        <option value="Great Lakes">Great Lakes</option>
                        <option value="Southeast">Southeast</option>
                        <option value="Northeast">Northeast</option>
                        <option value="Florida">Florida</option>
                        <option value="New England">New England</option>
                        <option value="Mid-Atlantic">Mid-Atlantic</option>
                        <option value="Texas">Texas</option>
                      </select>
                      <span class="placeholder">Region</span>
                    </div>

                    <div class="form-group">
                      <input
                        type="text"
                        class="form-control"
                        required
                        v-model="city"
                        v-on:keyup="errorNullTeam"
                      />
                      <span class="placeholder">City</span>
                    </div>
                    <div class="left-part-btns mb-2">
                      <button
                        type="button"
                        v-for="option in teamTypeOptions"
                        :key="option.value"
                        :class="{ active: teamType === option.value }"
                        @click="selectTeamType(option.value)"
                      >
                        {{ option.label }}
                      </button>
                    </div>

                    <div class="form-group" v-if="showSportType == 1">
                      <select
                        class="form-control"
                        :class="{
                          filled: sportType,
                          'is-invalid': $v.sportType.$error,
                          'is-valid': !$v.sportType.$invalid,
                        }"
                        v-model="sportType"
                        @change="errorNullTeam"
                      >
                        <option
                          v-for="option in sportOptions"
                          :key="option.id"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span class="placeholder">Sport Type</span>
                      <span
                        v-if="!$v.sportType.required"
                        class="invalid-tooltip"
                      >
                        Sport type is required
                      </span>
                    </div>

                    <div class="form-group" v-if="showSportType == 1">
                      <select
                        class="form-control"
                        id="ageGroup"
                        v-model="ageGroup"
                        @change="errorNullTeam"
                        :class="{
                          filled: ageGroup,
                          'is-invalid': $v.ageGroup.$error,
                          'is-valid': !$v.ageGroup.$invalid,
                        }"
                      >
                        <option
                          v-for="option in ageOptions"
                          :key="option.id"
                          :value="option.id"
                        >
                          {{ option.name }}
                        </option>
                      </select>
                      <span
                        v-if="!$v.ageGroup.required"
                        class="invalid-tooltip"
                      >
                        Age group is required
                      </span>
                      <span class="placeholder">Age Group</span>
                    </div>

                    <div class="left-part-btns mb-2">
                      <button
                        type="button"
                        v-for="option in genderOptions"
                        :key="option.id"
                        :class="{ active: gender === option.name }"
                        @click="selectGender(option.name)"
                      >
                        {{ option.name }}
                      </button>
                      <span
                        v-if="$v.gender.$error && !gender"
                        class="invalid-tooltip"
                      >
                        Gender is required
                      </span>
                    </div>

                    <!-- Rating dropdown -->
                    <div class="form-group" v-if="showSportType == 1">
                      <select
                        class="form-control"
                        :class="{ filled: rating }"
                        v-model="rating"
                        @change="errorNullTeam"
                      >
                        <option
                          v-for="option in ratingOptions"
                          :key="option.id"
                          :value="option.id"
                        >
                          {{ option.rate }}
                        </option>
                      </select>
                      <span class="placeholder">Rating</span>
                    </div>
                    <div class="form-group" :class="{ filled: lastUpdated }">
                      <date-picker
                        :open="open"
                        @close="open = false"
                        :editable="false"
                        :clearable="false"
                        @click.native="open = true"
                        v-model="lastUpdated"
                        valueType="format"
                        format="MMM DD, YYYY"
                      >
                        <i slot="icon-calendar" class="cursor-pointer">
                          <img src="../../../assets/Svg/calendar.svg" />
                        </i>
                      </date-picker>
                      <span class="placeholder">Last Updated</span>
                    </div>
                    <!-- WIF Approved -->

                    <div
                      class="d-flex align-items-center justify-content-between mb-3"
                    >
                      <span class="custom-format">WIF Approved</span>
                      <toggle-button
                        type="checkbox"
                        class="m-0 p-0  d-flex justify-content-end"
                        id="isChecked"
                        :width="34"
                        :sync="true"
                        :value="wifApproved"
                        v-model="wifApproved"
                      />
                    </div>

                    <!-- Email and Phone fields shown only when WIF Approved is checked -->
                    <div v-if="wifApproved" class="mt-2">
                      <div class="form-group">
                        <input
                          type="email"
                          class="form-control"
                          v-model="email"
                          required
                        />
                        <span class="placeholder">Email</span>
                      </div>
                      <div class="form-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="phone"
                          v-phone-mask
                          required
                        />
                        <span class="placeholder">Phone Number</span>
                      </div>
                    </div>

                    <div class="team-top-image mb-3">
                      <div class="team-image-create">
                        <img
                          v-if="this.groupAvatar.length == 0"
                          src="../../../assets/Svg/team-upload.svg"
                          alt=""
                          class="default-image"
                        />
                        <clipper-basic
                          v-else-if="this.groupAvatar.length > 0"
                          :src="this.rawData"
                          preview="preview"
                          :border="4"
                          :outline="0"
                          :corner="false"
                          :ratio="1"
                          :wrap-ratio="1"
                          :init-width="50"
                          :init-height="50"
                          ref="clipper"
                        ></clipper-basic>
                        <div class="edit-icon-wrapper" v-on:click="openinput">
                          <img
                            src="../../../assets/Svg/team/team-options/edit-2.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                    <input
                      type="file"
                      class="d-none"
                      id="vue-file-upload-input"
                      @change="addGroupAvatar"
                      accept="image/png, image/gif, image/jpeg"
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>

          <div class="event-btns-wrapper justify-content-end">
            <button
              type="button"
              class="btn btn-primary w-25"
              v-on:click="submitCombinedForm(0)"
              :disabled="isLoadingArray[0]"
            >
              <div v-if="isLoadingArray[0]" class="lds-dual-ring"></div>
              <span v-else>Continue</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
let states = require("../../../assets/js/state");

import { required } from "vuelidate/lib/validators";

export default {
  name: "AddTeam",
  props: {
    selectedRoomTeam: Object,
    singleEvent: Object,
    currentIsAdmin: String,
  },
  watch: {
    singleEvent: {
      handler(newVal) {
        console.log("singleEvent prop received:", newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      isDisabledTeam: false,
      open: false,
      openEnd: false,
      userName: localStorage.getItem("userName"),
      stateOptions: states,
      lastUpdated: "",
      isDisabledGame: true,
      ratingOptions: [],
      address: "",
      teamName: "",
      city: "",
      state: "",
      region: "",
      zipCode: "",
      wifApproved: false,
      teamAvatar: "",
      email: "",
      phone: "",
      marker: { position: { lat: 10, lng: 10 } },
      errorMessage: "",
      isLoadingArray: [],
      associationId: "",
      eventId: "",
      sportOptions: [],
      sportType: "",
      ageOptions: [],
      ageGroup: "",
      genderOptions: [
        { id: 1, name: "Male" },
        { id: 2, name: "Female" },
        { id: 3, name: "Coed" },
      ],
      gender: "",
      teamTypeOptions: [{ value: "sports", label: "Sports" }],
      teamType: "sports",
      groupAvatar: [],
      rawData: "",
      showSportType: 1,
      rating: "",
    };
  },

  validations: {
    teamName: { required },
    sportType: {
      required,
    },
    ageGroup: {
      required,
    },
    teamType: {
      required,
    },
    gender: {
      required,
    },
  },

  computed: {
    isFormValid() {
      return (
        this.teamName.trim() !== "" &&
        this.sportType !== "" &&
        this.ageGroup !== "" &&
        this.rating !== "" &&
        this.teamType !== ""
      );
    },
  },

  methods: {
    setPlace(place) {
      if (!place) return;
      this.marker.position = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      this.address = place.formatted_address;
      const addressComponents = place.address_components;

      for (const component of addressComponents) {
        const types = component.types;
        if (types.includes("locality")) {
          this.city = component.long_name;
        } else if (types.includes("administrative_area_level_1")) {
          this.state = component.short_name;
        } else if (types.includes("postal_code")) {
          this.zipCode = component.long_name;
        }
      }
      this.errorNullTeam();
    },
    errorNullTeam: function() {
      if (this.teamType == "sports") {
        this.showSportType = 1;
        if (
          this.teamName == "" ||
          this.teamType == "" ||
          this.sportType == "" ||
          this.ageGroup == "" ||
          this.gender == ""
        ) {
          this.isDisabledTeam = true;
        } else {
          this.isDisabledTeam = false;
        }
      } else {
        this.showSportType = 0;
        if (this.teamName == "" || this.teamType == "") {
          this.isDisabledTeam = true;
        } else {
          this.isDisabledTeam = false;
        }
      }
    },
    async submitCombinedForm(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      try {
        this.$set(this.isLoadingArray, index, true);
        this.isDisabledTeam = true;
        if (this.groupAvatar.length > 0) {
          const canvas = this.$refs.clipper.clip();
          const dataURL = canvas.toDataURL("image/jpeg", 0.95);
          const blob = this.dataURItoBlob(dataURL);
          const avatarFormData = new FormData();

          this.groupAvatar.forEach((value, index) => {
            avatarFormData.append(`images[${index}]`, blob);
          });

          const avatarResponse = await axios.post(
            `${process.env.VUE_APP_API_URL}chat/storeGroupAvatar`,
            avatarFormData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );

          this.teamAvatar = avatarResponse.data.data;
        }

        const teamFormData = new FormData();
        teamFormData.append("team_id", 0);
        teamFormData.append("created_by", 1);
        teamFormData.append("team_name", this.teamName);
        teamFormData.append("state", this.state);
        teamFormData.append("city", this.city);
        teamFormData.append("region", this.region);
        teamFormData.append("gender", this.gender);
        teamFormData.append("age_group", this.ageGroup);
        teamFormData.append("rate_id", this.rating);
        teamFormData.append("sport_type", this.sportType);
        teamFormData.append("team_type", this.teamType);
        teamFormData.append("wif_approved_status", this.wifApproved ? 1 : 0);
        teamFormData.append("email", this.email);
        teamFormData.append("phone_number", this.phone);
        const lastUpdatedDate = this.lastUpdated
          ? new Date(this.lastUpdated)
          : new Date();
        const formattedDate = lastUpdatedDate
          .toISOString()
          .slice(0, 19)
          .replace("T", " ");
        teamFormData.append("last_updated", formattedDate);

        if (this.teamAvatar) {
          teamFormData.append("team_avatar", this.teamAvatar);
        }

        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}chat/storeAdminTeam`,
          teamFormData
        );

        if (response.data.statusCode === 200) {
          this.$refs.openAddTeamsModal.click();
          this.resetForm();
          this.$root.$emit("openManageTeamsModal", {
            eventId: this.eventId,
            association_id: this.associationId,
          });
        } else {
          this.errorMessage = response.data.message;
        }
      } catch (error) {
        this.errorMessage =
          error.response?.data?.message || "An error occurred.";
      } finally {
        this.$set(this.isLoadingArray, index, false);
      }
    },

    getSportType() {
      this.errorNullTeam();
      axios
        .get(`${process.env.VUE_APP_API_URL}getSportType`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.sportOptions = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },

    getAgeGroup() {
      this.errorNullTeam();
      axios
        .get(`${process.env.VUE_APP_API_URL}getAgeGroup`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.ageOptions = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },

    getAllRating() {
      axios
        .get(`${process.env.VUE_APP_API_URL}getAllRatings`)
        .then((response) => {
          if (response.data.statusCode == 200) {
            this.ratingOptions = response.data.data.list;
          } else {
            this.errorMessage = response.data.message;
          }
        });
    },

    addGroupAvatar: async function(event) {
      const fileInput = document.getElementById("vue-file-upload-input");
      const file = event.target.files[0];
      const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;

      if (!allowedExtensions.exec(file.name)) {
        alert(
          "Please upload file having extensions .jpeg/.jpg/.png/.gif only."
        );
        fileInput.value = "";
        return false;
      }

      try {
        const resized = await this.resizeImage(file); // Resize before use

        this.groupAvatar.push({
          target: resized.blob, // Resized blob for preview/crop
          fileName: file.name,
          link: resized.url, // Blob URL to show in UI
        });

        this.rawData = resized.url; // Use in <clipper-basic> or <img> preview
      } catch (err) {
        console.error("Image resize failed:", err);
      }
    },

    resizeImage(file, maxSize = 1000) {
      return new Promise((resolve, reject) => {
        const fileSizeMB = file.size / (1024 * 1024);
        const mimeType = file.type; // Keep original format (e.g., image/png)

        if (fileSizeMB <= 5) {
          const originalUrl = URL.createObjectURL(file);
          return resolve({
            blob: file,
            url: originalUrl,
          });
        }

        const img = new Image();
        const reader = new FileReader();

        reader.onload = (e) => {
          img.src = e.target.result;
        };

        img.onload = () => {
          const canvas = document.createElement("canvas");
          const ratio = Math.min(maxSize / img.width, maxSize / img.height, 1);
          canvas.width = img.width * ratio;
          canvas.height = img.height * ratio;

          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          canvas.toBlob(
            (blob) => {
              const resizedURL = URL.createObjectURL(blob);
              resolve({
                blob: blob,
                url: resizedURL,
              });
            },
            mimeType,
            0.9
          ); // Keep original type (image/png, image/jpeg, etc.)
        };

        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },

    openinput() {
      document.getElementById("vue-file-upload-input").click();
    },

    dataURItoBlob(dataURI) {
      var byteString;
      if (dataURI.split(",")[0].indexOf("base64") >= 0)
        byteString = atob(dataURI.split(",")[1]);
      else byteString = unescape(dataURI.split(",")[1]);

      var mimeString = dataURI
        .split(",")[0]
        .split(":")[1]
        .split(";")[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },

    resetForm() {
      this.$v.$reset();
      this.address = "";
      this.teamName = "";
      this.city = "";
      this.state = "";
      this.region = "";
      this.zipCode = "";
      this.marker = { position: { lat: 10, lng: 10 } };
      this.errorMessage = "";
      this.isDisabledGame = true;
      this.sportType = "";
      this.ageGroup = "";
      this.rating = "";
      this.gender = "";
      this.groupAvatar = [];
      this.rawData = "";
      this.email = "";
      this.phone = "";
      this.wifApproved = false;
      this.isLoadingArray = [];
      this.lastUpdated = "";

      if (this.$refs.autocompleteRef) {
        const input = this.$refs.autocompleteRef.$el.querySelector("input");
        if (input) {
          input.value = "";
        }
      }
    },

    selectTeamType(value) {
      this.teamType = value;
      this.errorNullTeam();
    },

    selectGender(value) {
      this.gender = value;
    },
  },

  mounted() {
    this.$root.$on("openAddTeamsModal", (params) => {
      this.getSportType();
      this.getAgeGroup();
      this.getAllRating();
      const { eventId, association_id } = params || {};
      this.eventId = eventId;
      this.associationId = association_id;
      this.teamType = "sports";
      this.errorNullTeam();
      const elem = this.$refs.openAddTeamsModal;
      if (elem) {
        elem.click();
      } else {
        console.error("Ref 'openAddTeamsModal' is not found!");
      }
    });
  },
};
</script>
